__turbopack_context__.v({
  "attr": "criterion-chip-module__MK1kGW__attr",
  "dot": "criterion-chip-module__MK1kGW__dot",
  "frame": "criterion-chip-module__MK1kGW__frame",
  "not": "criterion-chip-module__MK1kGW__not",
  "op": "criterion-chip-module__MK1kGW__op",
  "opNot": "criterion-chip-module__MK1kGW__opNot",
  "or": "criterion-chip-module__MK1kGW__or",
  "sign": "criterion-chip-module__MK1kGW__sign",
  "srOnly": "criterion-chip-module__MK1kGW__srOnly",
  "text": "criterion-chip-module__MK1kGW__text",
  "value": "criterion-chip-module__MK1kGW__value",
});
